/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-09-10 19:14:41
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2025-02-08 09:42:37
 * @FilePath: \vue-hepha-order\src\views\stock\queryConfig\QueryForm.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const QueryForm = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'0px',
    formData:{},
    formField:[
        {
            // name:'order.orderSource', // 订单名称
            key:'order_name',
            type:'input',
            width:'200px',
            allowClear:true,
            placeholder:'order.orderName',
        },
        {
            // name:'order.orderSource', // mes出库单号
            key:'delivery_number',
            type:'input',
            width:'200px',
            allowClear:true,
            placeholder:'stock.deliveryNumber',
        },
        {
            // name:'order.deliverStatus', // 出库状态
            key:'status',
            type:'select',
            allowClear:true,
            width:'200px',
            optionToLocale:true,
            placeholder:'order.outboundStatus',
            options:[
                {
                    value:1,
                    label:'order.unOutbound'
                },
                {
                    value:7,
                    label:'order.uploading'
                },
                {
                    value:4,
                    label:'stock.outScanned'
                },
                {
                    value:2,
                    label:'order.outbound'
                },
                {
                    value:3,
                    label:'stock.cancelOutbound2'
                },
            ]
        },
        {
            // name:'order.orderSource', // sku
            key:'sku',
            type:'select',
            width:'200px',
            allowClear:true,
            placeholder:'order.sku',
            options:[],
        },
        // {
        //     // name:'order.orderSource', // 产品  erp物料号
        //     key:'inventory_code',
        //     type:'select',
        //     width:'260px',
        //     allowClear:true,
        //     multiple:true,
        //     placeholder:'order.inventoryCode',
        //     options:[],
        // },
        {
            // name:'order.erpNo', // SO
            key:'erp_no',
            type:'input',
            allowClear:true,
            width:'200px',
            placeholder:'order.erpNo',
        },
        {
            // name:'order.customerType', // 仓库
            key:'warehouse',
            type:'select',
            allowClear:true,
            width:'200px',
            placeholder:'order.warehouse',
            options:[]
        },
        {
            // name:'stock.frameNumber', //  车架号
            key:'frame_number',
            type:'input',
            allowClear:true,
            width:'200px',
            placeholder:'stock.frameNumber',
        },
        {
            // name:'order.customerType', // 物流公司
            key:'courier_type',
            type:'select',
            allowClear:true,
            width:'200px',
            optionToLocale:true,
            placeholder:'order.courierType',
            options:[]
        },
        {
            // name:'order.customerType', // 客户
            key:'customer_id',
            type:'select',
            allowClear:true,
            width:'200px',
            placeholder:'order.customerName',
            options:[]
        },
        {
            // name:'order.orderChannelType', // 订单类型
            key:'order_channel_type',
            type:'select',
            allowClear:true,
            width:'200px',
            placeholder:'order.orderChannelType',
            optionToLocale:true,
            options:[
                {
                    value:0,
                    label:'order.user'
                },
                {
                    value:1,
                    label:'order.dealer'
                },
                // {
                //     value:2,
                //     label:'order.ECommerceVendor',
                // },
                {
                    value:3,
                    label:'order.service'
                },
                {
                    value:5,
                    label:'order.c2c'
                },
            ]
        },
        {
            // name:'order.customerType', // 创建人
            key:'create_by',
            type:'select',
            allowClear:true,
            width:'200px',
            placeholder:'order.createUser',
            options:[]
        },
        {
            // name:'order.customerType', // 物料类别
            key:'category_code',
            type:'select',
            allowClear:true,
            width:'200px',
            placeholder:'stock.categoryType',
            options:[]
        },
        {
            // name:'order.customerType', //  备注
            key:'instruction',
            type:'input',
            allowClear:true,
            width:'200px',
            placeholder:'order.instruction',
        },
        {
            name:'', // 预计出库时间
            key:'transaction_date',
            type:'dateRange',
            allowClear:true,
            width:'310px',
            placeholder1:'stock.planShipStartDate',
            placeholder2:'stock.planShipEndDate',
        },
        {
            name:'', // 实际出库时间
            key:'delivery_date',
            type:'dateRange',
            allowClear:true,
            width:'310px',
            placeholder1:'stock.realShipStartDate',
            placeholder2:'stock.realShipEndDate',
        },
    ]
}

const QueryForm2 = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'30px',
    showSlot:true,
    formData:{},
    formField:[
        {
            // name:'order.customerType', // 仓库
            key:'warehouse',
            type:'select',
            allowClear:true,
            width:'260px',
            placeholder:'order.warehouse',
            options:[]
        },
        {
            name:'stock.plan', // 预计出库时间
            key:'transaction_date',
            type:'dateRange',
            allowClear:true,
            width:'220px',
            marginLeft:'40px'
        },
        {
            name:'stock.real', // 实际出库时间
            key:'delivery_date',
            type:'dateRange',
            allowClear:true,
            width:'220px',
            marginLeft:'40px'
        },
    ]
}

const EditForm = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'130px',
    showSlot:true,
    formData:{},
    formField:[
        {
            name:'order.courierType', // 物流公司
            key:'courier_type',
            type:'select',
            allowClear:true,
            disabled:true,
            width:'260px',
            options:[]
        },
        {
            name:'order.courierNo', // 物流单号
            key:'courier_no',
            type:'input',
            allowClear:true,
            disabled:true,
            width:'260px',
        },
        {
            name:'order.courierLink', // 物流链接
            key:'courier_url',
            type:'input',
            allowClear:true,
            disabled:true,
            width:'260px',
        },
        {
            name:'order.courierStatus', // 物流状态
            key:'courier_status',
            type:'select',
            allowClear:true,
            // disabled:true,
            width:'260px',
            optionToLocale:true,
            options:[
                // {
                //     label:'order.unship',
                //     value:0,
                // },
                // {
                //     label:'order.plan',
                //     value:1,
                // },
                // {
                //     label:'order.partialShip',
                //     value:2,
                // },
                {
                    label:'order.shiped',
                    value:3,
                },
                // {
                //     label:'order.signedFor',
                //     value:4,
                // }
            ]
        },
        {
            name:'stock.cargoFreight', // 运费
            key:'cargo_freight',
            type:'input',
            width:'260px',
            allowClear:true,
            prefix:true,
            // hideButton:true,
        },
        // {
        //     name:'order.frameNumber', // 车架号
        //     key:'frame_number',
        //     type:'input',
        //     width:'260px',
        //     allowClear:true,
        //     disabled:true,
        // },
    ]
}


QueryForm.formField.forEach(item=>{
    if(item.key == 'warehouse'){
        QueryForm.formData['warehouse_list'] = []
    }else{
        QueryForm.formData[item.key] = ''
    }
})

QueryForm2.formField.forEach(item=>{
    QueryForm2.formData[item.key] = ''
})

EditForm.formField.forEach(item=>{
    EditForm.formData[item.key] = ''
})


export {
    QueryForm,
    QueryForm2,
    EditForm,
}